<script setup>
import BaseHeader from "@/components/base/base-header.vue";
import {useRouter, useRoute} from "vue-router";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useCompanyStore} from "@/stores/company.js";
import {Auth} from "@/core/api/auth.js";
import {Processes} from "@/core/api/processes.js";
import {onMounted} from "vue";
import {Orders} from "@/core/api/orders.js";
import BaseFooter from "@/components/base/base-footer.vue";
import {Wishlist} from "@/core/api/wishlist.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import translation from "@/core/helpers/translations.js";
import translations from "@/core/helpers/translations.js";
import {useRecaptchaProvider} from "vue-recaptcha";

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const cartStore = useCartStore()
const companyStore = useCompanyStore()
const wishlistStore = useWishlistStore()

useRecaptchaProvider()

const logOut = async () => {
  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('ngs-locale') || 'en-gb'
    }
  })

  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('ngs-refresh')
  localStorage.removeItem('ngs-remember')
}

const checkUserAuth = async () => {
  const companyRes = await Processes.getCompanyInfo()

  if (companyRes) {
    companyStore.setCompanyInfo(companyRes.data.parameters)
  }

  if (localStorage.getItem('ngs-remember')) {
    const res = await Auth.refresh()

    if (res?.data) {
      authStore.setUser({
        user: res.data.refreshJwtToken.user,
        accessToken: res.data.refreshJwtToken.accessToken
      })

      if (res.data.refreshJwtToken.user.language.toLowerCase() !== translation.currentLocale) {
        translations.switchLanguage(res.data.refreshJwtToken.user.language)
        await router.push({
          name: route.name,
          params: {
            locale: localStorage.getItem('ngs-locale') || 'en-gb'
          }
        })
      }

      localStorage.setItem('ngs-refresh', res.data.refreshJwtToken.refreshToken)

      const currentOrder = await Orders.getOrders("PENDING", res.data.refreshJwtToken.accessToken, res.data.refreshJwtToken.user.email)
      cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)

      const wishlistRes = await Wishlist.getWishlist(res.data.refreshJwtToken.accessToken)
      wishlistStore.wishlist = wishlistRes.data.wishlists.edges[0].node
    }
  }
}

onMounted(async () => {
  await checkUserAuth()

  setInterval(async () => {
    await checkUserAuth()
  }, 600000)
})
</script>

<template>
  <div class="main">
    <base-header />
    <RouterView v-slot="{ Component }" id="top">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <base-footer />
  </div>
</template>

<style lang="scss">
.main {

}

.el-notification {
  border-radius: 10px;
  padding: 20px;
  background: linear-gradient(white, white) padding-box,
             linear-gradient(135deg, #EB5393 25%, #FF6162 75%) border-box;
  border: 2px solid transparent;
  overflow: visible;

  color: #2F2F2F;
  font-size: 32px;
  font-weight: 600;
  line-height: 41px;
  letter-spacing: -0.32px;
}

.el-notification .el-notification__closeBtn {
  color: #FF6162;
}
.el-notification .el-notification__closeBtn:hover {
  color: #FF6162;
}
</style>